import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import { Frame } from './components/Frame/index.js';
import { Tabs } from './components/Tabs.js';
import { Modal, Panel, FigureShopify } from '@studiometa/ui';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Frame,
      Modal,
      Panel,
      Tabs,
      FigureShopify,
      ProductLastViewed: (app) =>
        importWhenVisible(
          () => import('./components/Sections/ProductLastViewed.js'),
          'ProductLastViewed',
          app,
        ),
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./components/Sections/ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
    },
  };

  /**
   *
   */
  mounted() {
    console.log('mounted', this.$children.FigureShopify);
  }
}

export default createApp(App, document.documentElement);
